module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "last"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "info"
  }, [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "head"
  }, [_vm._v("\n                    Weleda на Пикнике «Афиши»!\n                ")]), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("\n                    4 августа в парке «Коломенское» прошел грандиозный Пикник «Афиши», на котором специально для вас мы создали отдельный уголок природы.\n                    Здесь можно было почувствовать аромат лимонов, ощутить магию летнего сада и поближе познакомиться с натуральной косметикой.\n                    Вновь насладиться моментом можно в нашем "), _c('a', {
    staticClass: "line",
    attrs: {
      "target": "_blank",
      "href": "https://www.instagram.com/weledarussia"
    },
    nativeOn: {
      "click": function($event) {
        _vm.gaEvents('main', 'click', 'instagram')
      }
    }
  }, [_vm._v("Instagram")]), _vm._v(" по тегу "), _c('strong', [_vm._v("#WeledaPicnic")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "btn btn-promo",
    on: {
      "click": _vm.show
    }
  }, [_vm._v("\n                    Получить скидку на косметику\n                ")]), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('Form', {
    attrs: {
      "showForm": _vm.showForm,
      "showCloseMobile": true
    },
    on: {
      "closeForm": _vm.close
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "point"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("\n                    Москва, Коломенское\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "desc"
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline"
    },
    attrs: {
      "href": "/static/pdf/rules.pdf",
      "target": "_blank"
    }
  }, [_vm._v("Правила участия")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footnote"
  }, [_c('p', [_vm._v("*Веледа")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4315a67b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/parts/last.vue
// module id = 536
// module chunks = 1